import { render, staticRenderFns } from "./AddDriver.vue?vue&type=template&id=b89849c6"
import script from "./AddDriver.vue?vue&type=script&lang=js"
export * from "./AddDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports